import merge from "@tinkoff/utils/object/mergeDeep";
import { getThresholdColor, getThresholdValue } from "../thresholds";
export default function thresholdColorTransformer(thresholds) {
    thresholds = thresholds.sort((a, b) => getThresholdValue(a) - getThresholdValue(b));
    return function thresholdColorTransformer(series) {
        return series.map((mapSeries) => {
            return merge(mapSeries, {
                data: mapSeries.data.map((point) => {
                    let pointValue = point.num;
                    if (typeof point.metric !== "undefined") {
                        pointValue = point.metric;
                    }
                    for (const threshold of thresholds) {
                        if (pointValue <= getThresholdValue(threshold)) {
                            return merge(point, { color: getThresholdColor(threshold) });
                        }
                    }
                    return point;
                }),
            });
        });
    };
}
